import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import TariffCodeByCompanyContMain from "presentation/view/container/TariffCodeByCompany/TariffCodeByCompanyContMain";

CommonEntrypoint(<TariffCodeByCompanyContMain/>)